import { onGoogleConsentChange } from "./googleConsent"
import { setResultCookie } from "./cookie"
import { onAdobeConsentChange } from "./adobeConsent"
import { bindScroll } from "./scroll"
import { exposure } from "./exposure"

// 埋点
const platformExposure = (trackCode, options = {}) => {
    try {
        exposure.addExposure(trackCode, options);
    } catch (e) {
        console.log(e)
    }
}

export const renderConsentModal = (data) => {
    const dom = document.createElement("div")
    const {consentTitle = "", consentDescription = "", acceptButton = "", manageTrackingButton = ""} = data;
    dom.innerHTML = `
    <div id="js-cookie-modal" class="sl-cookie-modal text-font">
        <div class="sl-cookie-modal-content" data-nosnippet>
            <div class="sl-cookie-modal-title">${consentTitle}</div>
            <div class="sl-cookie-modal-desc">${consentDescription}</div>
            <div class="sl-cookie-modal-footer">
                <div>
                    <div class="sl-cookie-modal-link" id="js-cookie-manage-open">${manageTrackingButton}</div>
                </div>
                <div class="sl-cookie-modal-btn" id="js-cookie-manage-accept-all">${acceptButton}</div>
            </div>
        </div>
    </div>
    `;
    document.body.appendChild(dom)
}

export const renderManageModal = (data) => {
    const dom = document.createElement("div")

    const {manageTrackingTitle = "", manageTrackingMobileTitle = "", manageTrackingDescription = "", manageTrackingCheckList = [],saveButton = "", manageTrackingBack = ""} = data;

    let optionsDom = ""
    manageTrackingCheckList.map(item => {
        const {policyDescription, policyType, defaultChecked, notEditable} = item;
        optionsDom += `<label class="sl-cookie-modal-option-item">
            <input type="checkbox" ${defaultChecked ? "checked" : ""} ${notEditable ? "disabled" : ""} name=${policyType}>
            <span></span>
            ${policyDescription}
        </label>`
    })
    dom.innerHTML = `
    <div id="js-cookie-manage" class="sl-cookie-modal text-font" style="display:none;">
        <div class="sl-cookie-modal-content sl-cookie-modal-content-second" data-nosnippet>
            <div class="sl-cookie-modal-header">
                <div id="js-cookie-manage-header-back" class="sl-cookie-modal-header-back"></div>
                <div>${manageTrackingMobileTitle}</div>
            </div>
            <div class="sl-cookie-modal-title sl-cookie-modal-pc">${manageTrackingTitle}</div>
            <div class="sl-cookie-modal-container">
                <div class="sl-cookie-modal-title sl-cookie-modal-mobile">${manageTrackingTitle}</div>
                <div class="sl-cookie-modal-desc">${manageTrackingDescription}</div>
                <div class="sl-cookie-modal-option">
                    <form id="js-cookie-manage-form">
                        ${optionsDom}
                    </form>
                </div>
            </div>

            <div class="sl-cookie-modal-footer">
                <div class="sl-cookie-modal-back" id="js-cookie-manage-back">${manageTrackingBack}</div>
                <div class="sl-cookie-modal-btn" id="js-cookie-manage-submit">${saveButton}</div>
            </div>
        </div>
    </div>
    `;
    document.body.appendChild(dom)
}


export const renderHtml = (data) => {
    renderConsentModal(data)
    renderManageModal(data)

    platformExposure("Consent_Popup", {
        itemParams: {
            "itemType": "page view",
        }
    })
}

// const trackAdobe = (isAll) => {
//    try {
//         if (window.wa && window._satellite) {
//             window.wa.PreviousButtonClick = isAll ? "Consent_mode_choose_all" : "Consent_mode_choose_part";
//             window._satellite && window._satellite.track('click')
//         }
//    } catch (e) {
//    }
// }

export const submitUserChoose = (data, grantedList) => {
    // 更新cookie，调用对应政策相关数据
    try {
        const result = {};
        const policyTypeList = data?.policyTypeList || {}
        const policyTypeKeys = Object.keys(policyTypeList);
        const resultGrantedList = grantedList || policyTypeKeys;
        const isAll = grantedList && grantedList?.length ? grantedList.length === policyTypeKeys.length : true;

        resultGrantedList.forEach(policyType => {
            if (policyTypeList?.[policyType]?.length) {
                policyTypeList[policyType].forEach(item => {
                    const {thirdPartyCode, key} = item;
                    if (key && thirdPartyCode) {
                        if(!result[thirdPartyCode]) {
                            result[thirdPartyCode] = []
                        }
    
                        if (result[thirdPartyCode].indexOf(key) === -1) {
                            result[thirdPartyCode].push(key)
                        }
                    }
                })
            }
        })


        if(Object.keys(result).length) {
            setResultCookie(result, isAll)
            result.google && onGoogleConsentChange(result.google)
            result.adobe && onAdobeConsentChange(result.adobe)
            
            // zd4794 移除埋点
            // trackAdobe(isAll) 

            const trackCode = isAll ? "Click_Consent_All" : "Click_Consent_" + resultGrantedList.join("_")
            platformExposure(trackCode)
        }
    } catch (e) {
        console.log(e)
    }
}


const BODY_HIDDEN_CLASS = "sl-cookie-modal-body-hidden";

export const bindEvent = (data) => {
    // 获取dom
    const cookieModal = document.getElementById("js-cookie-modal"); //一级弹窗
    const openManage = document.getElementById("js-cookie-manage-open"); //打开二级弹窗按钮
    const acceptAll = document.getElementById("js-cookie-manage-accept-all"); //一级弹窗同意所有按钮

    const manageModal = document.getElementById("js-cookie-manage"); //二级弹窗
    const manageHeaderBack = document.getElementById("js-cookie-manage-header-back"); //二级弹窗返回按钮-header
    const manageBack = document.getElementById("js-cookie-manage-back"); //二级弹窗返回按钮
    const manageSubmit = document.getElementById("js-cookie-manage-submit"); //二级弹窗表单提交
    const manageForm = document.getElementById("js-cookie-manage-form"); //二级弹窗表单


    const closeModal = () => {
        cookieModal.style.display = "none"
        manageModal.style.display = "none"
        document.body.className = document.body.className.replace(BODY_HIDDEN_CLASS, "")
    }

    const openManageModal = () => {
        cookieModal.style.display = "none"
        manageModal.style = ""
    }

    const closeManageModal = () => {
        manageModal.style.display = "none"
        cookieModal.style = ""
    }

    openManage.addEventListener("click", openManageModal)

    manageHeaderBack.addEventListener("click", closeManageModal)

    manageBack.addEventListener("click", closeManageModal)

    // fb项目中会有混动穿透的问题
    document.body.className += ` ${BODY_HIDDEN_CLASS}`
    cookieModal.addEventListener("touchmove", (event) => {event.stopPropagation()})
    manageModal.addEventListener("touchmove", (event) => {event.stopPropagation()})

    acceptAll.addEventListener("click", () => {
        // 同意所有，关闭弹窗
        submitUserChoose(data)
        closeModal()
    })

    manageSubmit.addEventListener("click", () => {
        // 同意部分，提交表单，关闭弹窗
        const formDom = manageForm.querySelectorAll("input");
        const grantedList = [];
        formDom.forEach(item => {
            if(item.name && item.checked) {
                grantedList.push(item.name);
            }
        })
        submitUserChoose(data, grantedList)
        closeModal()
    })

    if(window.___yoTapEventInjected) {
        bindScroll(document.querySelector(".sl-cookie-modal-container"))
    }
}


export const onReady = (callback) => {
    function completed() {
        try{
            detach();
            callback();
        }catch(e){
            console.log(e)
        }
       
    } 

    function detach() {
        if ( document.addEventListener ) {
            document.removeEventListener( "DOMContentLoaded", completed, false );
            window.removeEventListener( "load", completed, false );
     
        } else {
            document.detachEvent( "onreadystatechange", completed );
            window.detachEvent( "onload", completed );
        }
    
    }

        
    
    if (document.readyState !== "loading") {
        //如果DOM已经完成，直接调用jQuery.ready方法，但是setTimeout没有第二个参数!
        //这是为了防止IE的!
        // Handle it asynchronously to allow scripts the opportunity to delay ready
        setTimeout(callback);
    } else if (document.addEventListener) {
        //为什么要同时检测DOMContentLoaded和load，因为有些浏览器中会缓存load事件
        //所以会先触发load，后触发DOMContentLoaded，所以看那个更快就行!
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed, false);
        // A fallback to window.onload, that will always work
        window.addEventListener("load", completed, false);
        // If IE event model is used
    } else {
        // Ensure firing before onload, maybe late but safe also for iframes
        document.attachEvent("onreadystatechange", completed);
        // A fallback to window.onload, that will always work
        window.attachEvent("onload", completed);
    }
};